import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreateNewGroupForm from './CreateNewGroupForm'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import { ApplicationTitle, ProjectListTitle } from '../../../Utils/Constants'

export default function GroupCreateContainer() {
    return (
        <>
            <Breadcrumbs pageTitle={ProjectListTitle} parent={"Group List"} title={"Create New Group"} />
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <Card>
                            <CardBody>
                                <CreateNewGroupForm />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}